// Self-hosted consent gate for analytics/marketing trackers (CIPA Phase 1).
const STORAGE_KEY = 'dsp_cookie_consent';
const CONSENT_VERSION = 1;
const GA4_ID = 'G-6CNTP2E601';

let trackersLoaded = false;

export function getConsent() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && (parsed.state === 'granted' || parsed.state === 'denied') ? parsed.state : null;
  } catch (e) {
    return null;
  }
}

export function setConsent(state) {
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ state, ts: Date.now(), v: CONSENT_VERSION }),
    );
  } catch (e) {
    /* localStorage unavailable — fail closed (no persistence, banner shows next visit) */
  }
}

export function clearConsent() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    /* no-op */
  }
}

export function gtagConsentUpdate(state) {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag('consent', 'update', {
    ad_storage: state,
    ad_user_data: state,
    ad_personalization: state,
    analytics_storage: state,
  });
}

export function loadTrackers() {
  if (trackersLoaded) return;
  trackersLoaded = true;
  try {
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    s.setAttribute('data-consent-tracker', 'ga4');
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', GA4_ID);

    gtagConsentUpdate('granted');
  } catch (e) {
    /* tracking is best-effort; never break the app */
  }
}
